module.exports = {"451402001":"太平街道","451402002":"江南街道","451402003":"石景林街道","451402101":"新和镇","451402102":"濑湍镇","451402103":"江州镇","451402104":"左州镇","451402105":"那隆镇","451402106":"驮卢镇","451402201":"罗白乡","451402202":"板利乡","451402400":"新和华侨农场","451402401":"左江华侨农场","451402402":"中泰产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451402.json
// module id = 2176
// module chunks = 0